import React from 'react'
import Footer from './Footer'

export default function LayoutMain({ children }) {
  return (
    <>
      {children}
      <Footer />
    </>
  )
}
